import { MainTextRow } from '/src/features/live-activity/components/ui';
import { Identity } from '../EventCard';

export function SignupEvent({ liveEvent, identifyEvents }) {
  return (
    <div>
      <MainTextRow>
        <Identity id={liveEvent.data?.visitor_id} identifyEvents={identifyEvents} />
        signed up!
      </MainTextRow>
    </div>
  );
}
